(function() { window.GUID_dd0eb8c3_bc4e_4720_8564_db9856d1f16f = { getGuid: function() { return "dd0eb8c3-bc4e-4720-8564-db9856d1f16f"; } }; })();
var CS;
(function (CS) {
    let lastfocusedWatermark = null;
    class WaterMark {
        constructor(input, forceOn, showFocusedTooltip) {
            let me = this;
            if (showFocusedTooltip == null) {
                showFocusedTooltip = true;
            }
            if (forceOn != null) {
                input.addClass(forceOn);
            }
            let waterMarkText = input.data('watermark');
            if (input.val() == '' && !input.is(':focus')) {
                input.val(waterMarkText);
                input.addClass('watermark');
            }
            input.focus(function () {
                if (showFocusedTooltip) {
                    me.ShowWatermarkBubbleText(input);
                }
                if ($(this).val() == waterMarkText) {
                    $(this).val("");
                    input.removeClass('watermark');
                    if (input.data('ispassword') == true) {
                        input.attr('type', 'password');
                    }
                }
            });
            input.blur(function () {
                if (lastfocusedWatermark != null) {
                    lastfocusedWatermark.remove();
                }
                if ($(this).val() == '') {
                    $(this).val(waterMarkText);
                    input.addClass('watermark');
                    if (input.attr('type') == 'password') {
                        input.data('ispassword', true);
                        input.attr('type', 'text');
                    }
                }
            });
        }
        SetStyle() { }
        ShowWatermarkBubbleText(target) {
            if (lastfocusedWatermark != null) {
                lastfocusedWatermark.remove();
            }
            target.one('keydown', function () {
                if (lastfocusedWatermark != null) {
                    lastfocusedWatermark.remove();
                }
            }).one('blur', function () {
                if (lastfocusedWatermark != null) {
                    lastfocusedWatermark.remove();
                }
            });
            if (!target.is("[data-tooltip]") && target.closest('[data-tooltip]').length == 0) {
                var focusedWatermark = $("<div id='FocusedWatermark'><div id='FocusedWatermarkText'>" + target.data('watermark') + "</div><div id='FocusedWatermarkArrow'></div></div>");
                CS.body.append(focusedWatermark);
                lastfocusedWatermark = focusedWatermark;
                var customClass = CompuSport.Layout.PositionTargetRefToSourceAndWindows(target, focusedWatermark);
                focusedWatermark.addClass(customClass);
                CS.win.on('resize.watermark', function () {
                    var customClass = CompuSport.Layout.PositionTargetRefToSourceAndWindows(target, focusedWatermark);
                    focusedWatermark.removeClass('LayoutHelperRight');
                    focusedWatermark.removeClass('LayoutHelperTop');
                    focusedWatermark.removeClass('LayoutHelperLeft');
                    focusedWatermark.removeClass('LayoutHelperBottom');
                    focusedWatermark.addClass(customClass);
                });
            }
        }
    }
    CS.WaterMark = WaterMark;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSWaterMark = function (forceOn, showFocusedTooltip) {
        this.each(function () {
            var watermark = new CS.WaterMark($(this), forceOn, showFocusedTooltip);
        });
    };
})(jQuery);


var lastfocusedWatermark = null;

var CS = CS || {};

CS.WaterMark = function (me, forceOn, showFocusedTooltip) {
    var input = $(me);
    if (showFocusedTooltip == null)
    {
        showFocusedTooltip = true;
    }
    if (forceOn != null) {
        input.addClass(forceOn);
    }
    var waterMarkText = input.data('watermark');

    if (input.val() == '' && !input.is(':focus')) {
        input.val(waterMarkText);
        input.addClass('watermark');
    }

    input.focus(function () {
        if (showFocusedTooltip) {
            ShowWatermarkBubbleText(input);
        }
        if ($(this).val() == waterMarkText) {
            $(this).val("");
            input.removeClass('watermark');
            if (input.data('ispassword') == true) {
                input.attr('type', 'password');
            }
        }
    });
    input.blur(function () {
        if (lastfocusedWatermark != null) {
            lastfocusedWatermark.remove();
        }
        if ($(this).val() == '') {
            $(this).val(waterMarkText);
            input.addClass('watermark');
            if (input.attr('type') == 'password') {
                input.data('ispassword', true);
                input.attr('type', 'text');
            }
        }
    });

};

CS.WaterMark.prototype = function () {

    var SetStyle = function () {

    };
    return {
        SetStyle: SetStyle
    };

}();

function ShowWatermarkBubbleText(target) {
    if (lastfocusedWatermark != null) {
        lastfocusedWatermark.remove();
    }

    target.one('keydown', function () {
        if (lastfocusedWatermark != null) {
            lastfocusedWatermark.remove();
        }
    }).one('blur', function () {
        if (lastfocusedWatermark != null) {
            lastfocusedWatermark.remove();
        }
    });

    if (!target.is("[data-tooltip]") && target.closest('[data-tooltip]').length == 0) {
        var focusedWatermark = $("<div id='FocusedWatermark'><div id='FocusedWatermarkText'>" + target.data('watermark') + "</div><div id='FocusedWatermarkArrow'></div></div>");
        CS.body.append(focusedWatermark);
        lastfocusedWatermark = focusedWatermark;
        var customClass = CompuSport.Layout.PositionTargetRefToSourceAndWindows(target, focusedWatermark);

        focusedWatermark.addClass(customClass);

        CS.win.on('resize.watermark', function () {
            var customClass = CompuSport.Layout.PositionTargetRefToSourceAndWindows(target, focusedWatermark);
            focusedWatermark.removeClass('LayoutHelperRight');
            focusedWatermark.removeClass('LayoutHelperTop');
            focusedWatermark.removeClass('LayoutHelperLeft');
            focusedWatermark.removeClass('LayoutHelperBottom');
            focusedWatermark.addClass(customClass);
        });
    }
   
}
*/ 

//# sourceMappingURL=cs.watermark.js.map
